import i18n from '@/lang/index'
//新增配置
export const addColumn = [
    {
        prop: 'goodsName',
        label: i18n.t('invoicesCenter.columnGoodsname')
    },
    {
        prop: 'goodsNo',
        label: i18n.t('invoicesCenter.columnGoodsno')
    },
    {
        prop: 'colorValue',
        label: i18n.t('invoicesCenter.columnColorvalue')
    },
    {
        prop: 'sizeInfoList',
        width: '1200px',
        boxWidth: '150px' //复选框宽度
    },
    {
        prop: 'total',
        label: i18n.t('invoicesCenter.columnTotal'),
        type: 'count',
        getTotal(row, _key) {
            return row.sizeInfoList.reduce((c, R) => c + Number(R[_key] ? R[_key] : 0), 0)
        }
    }
]

export const addSizeInfoLabel = [
    {
        prop: 'usableQuantity', //复选框key//valueInfoList当前行对应key
        label: i18n.t('invoicesCenter.sizeinfoUsablequantity'), //复选框名称及行数据对应名称
        checkShow: false, //是否出现复选框
        value: true, //绑定值
        disabled: true //禁用
    },
    {
        prop: 'number', //复选框key//valueInfoList当前行对应key
        label: i18n.t('invoicesCenter.sizeinfoNumber'), //复选框名称及行数据对应名称
        checkShow: false, //是否出现复选框
        value: true, //绑定值
        disabled: true, //禁用
        colType: 'addInput', //当前行是否为输入框
        getRowBgc(_row) {
            if (+_row.number !== 0) {
                return 'row-bg-green'
            } else {
                return ''
            }
        }
    }
]
export const addActions = {
    fixedWidth: 120,
    list: [
        {
            label: i18n.t('invoicesCenter.actionsDel'),
            event: 'del',
            displayRule: (row) => true
        }
    ]
}
export const footerObj = [
    {
        prop: "totalAmount",
        label: i18n.t('invoicesCenter.footerTotalamount'),
        unit: i18n.t('invoicesCenter.unitTotalamount'),
        formula(data) {
            let sum = 0
            data.forEach((item) => {
                for (let i of item.sizeInfoList) {
                    if (+i.number > 0) {
                        sum++
                        break
                    }
                }
            })
            return sum
        },
    },
    {
        prop: 'tcGetNum',
        label: i18n.t('invoicesCenter.footerTcgetnum'),
        unit: '',
        formula(data) {
            let num = 0
            data.forEach((item) => {
                let all = item.sizeInfoList.reduce((c, R) => c + Number(R.number*1 || 0), 0)
                num += all
            })
            return num
        }
    },
   
]